import jQuery from "jquery"
window.$ = jQuery

import { initMatomo } from './assets/js/matomo'
if (process.env.NODE_ENV === 'production') {
    initMatomo();
}

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import 'bootstrap/dist/css/bootstrap.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueI18n from 'vue-i18n'
import eng from './assets/i18n/eng.json'
import nbo from './assets/i18n/nbo.json'
import nny from './assets/i18n/nny.json'
import BootstrapVue from 'bootstrap-vue';

//import * as process from "process";
import {NODE_ENV} from "@fortawesome/vue-fontawesome/examples/vue-cli-webpack/config/prod.env";
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// Load the full build.
require('lodash');
Vue.prototype.$eventBus = new Vue();

Vue.use(
  VueI18n)

library.add(faArrowRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

var messages = {
  eng: {
    message:eng
  },
  nbo: {
    message:nbo
  },
  nny: {
    message:nny
  }
}
// Create VueI18n instance with options
var i18n = new VueI18n({
  locale: localStorage.getItem('lang') === null ? 'nbo' : localStorage.getItem('lang'), // set locale
  messages, // set locale messages
})

localStorage.setItem('lang', i18n.locale);

// Fetch apiUrl from environment variable.
const apiUrl = (process.env.VUE_APP_API_URL || 'https://api.example.lexin') + '/api/v1';
const apiEnableCache = parseInt(process.env.VUE_APP_ENABLE_CACHE || '1');
const axiosParams = {
    baseURL: apiUrl,
    headers: { 'Cache-Control': 'no-cache' },
}

if (apiEnableCache == 1) {
    axiosParams['adapter'] = cacheAdapterEnhancer(axios.defaults.adapter);
}

var base = axios.create(axiosParams);
Vue.use(BootstrapVue);
Vue.prototype.$http = base

if (process.env.NODE_ENV === 'production') {
    /* Matomo pageview tracking. Is initialized in index.html */
    router.afterEach((to) => {
        if (!window._paq) return;
        _paq.push(['setCustomUrl', window.location.href]);
        _paq.push(['setDocumentTitle', document.title]);
        _paq.push(['trackPageView']);
    });
}

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
